import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";

export const ProductCard = ({ product }) => {
  const { addItem } = useCart();

  const quickAdd = (e) => {
    e.preventDefault();
    const size = product.sizes?.length ? product.sizes[0] : null;
    addItem(product, size, 1);
    toast.success(`${product.name} added to cart`);
  };

  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block bg-[#121212] border border-white/10 hover:border-white/30 hover:-translate-y-1 transition-[transform,border-color] duration-150"
    >
      <div className="relative overflow-hidden bg-[#1A1A1A] aspect-square">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-[transform,opacity] duration-300"
        />
        {product.featured && (
          <span className="absolute top-3 left-3 bg-[#C5A059] text-black text-[10px] font-bold uppercase tracking-wider px-2 py-1">
            Featured
          </span>
        )}
        <span className="absolute top-3 right-3 bg-black/60 backdrop-blur text-white text-[10px] font-bold uppercase tracking-wider px-2 py-1">
          {product.category}
        </span>
      </div>
      <div className="p-4 flex items-start justify-between gap-3">
        <div>
          <h3 className="font-heading text-lg font-700 uppercase tracking-tight leading-none text-white group-hover:text-[#E63946] transition-colors">
            {product.name}
          </h3>
          <p className="text-[#A1A1AA] text-sm mt-1">${product.price.toFixed(2)}</p>
        </div>
        <button
          onClick={quickAdd}
          data-testid={`quick-add-${product.id}`}
          className="shrink-0 bg-[#E63946] hover:bg-[#FF4D5A] text-white w-9 h-9 flex items-center justify-center transition-colors"
          title="Add to cart"
        >
          <Plus size={18} />
        </button>
      </div>
    </Link>
  );
};
